// Only apply the configured domain to cookies if the current hostname is that
// domain or a subdomain of it. Otherwise (local dev, Codespaces, preview URLs)
// leave it undefined so the browser scopes cookies to the current host — a
// mismatched `domain` attribute causes the browser to silently drop the cookie.
const configuredDomain = import.meta.env.VITE_DOMAIN as string | undefined;
const hostMatchesConfiguredDomain = (): boolean => {
  if (!configuredDomain || typeof window === 'undefined') return false;
  const host = window.location.hostname;
  const target = configuredDomain.startsWith('.') ? configuredDomain.slice(1) : configuredDomain;
  return host === target || host.endsWith(`.${target}`);
};
export const domain: string | undefined = hostMatchesConfiguredDomain()
  ? configuredDomain
  : undefined;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_TINUITI_GOOGLE_CLIENT_ID as string;

export const ACCESS_TOKEN_LIFE = 1000 * 60 * 60 * 24; // 24 hours in ms
export const ACCESS_TOKEN_LIFE_DELTA = 1000 * 60 * 60 * 23 + 1000 * 60 * 30; // 23 hours and 30 minutes in ms

export const AuthCookies = {
  ACCESS_TOKEN_EXPIRATION: 'access_token_expiration',
  ACCESS_TOKEN: 'access_token',
  GOOGLE_API_ACCESS_TOKEN_EXPIRATION: 'google_api_access_token_expiration',
  GOOGLE_API_ACCESS_TOKEN: 'google_api_access_token',
  LOGIN_METHOD: 'login_method',
  GOOGLE_REFRESH_TOKEN: 'google_refresh_token'
} as const;

export interface GoogleTokenResponse {
  access_token: string;
}

export interface GoogleTokenClient {
  requestAccessToken: (opts?: { prompt?: string }) => void;
}

export interface GoogleOAuth2 {
  initTokenClient: (config: {
    client_id: string;
    scope: string;
    auto_select?: boolean;
    // Pre-selects the Google account (by email) so GSI skips the account chooser when that
    // account already has an active session and granted consent. See ensureGoogleApiAccessToken.
    hint?: string;
    callback: (response: GoogleTokenResponse) => void;
  }) => GoogleTokenClient;
  initCodeClient: (config: unknown) => { requestCode: () => void };
  revoke: () => void;
}

export interface GoogleAccounts {
  oauth2: GoogleOAuth2;
}

declare global {
  interface Window {
    google?: {
      accounts: GoogleAccounts;
    };
    Cypress?: boolean;
  }
}
